<form (ngSubmit)="save()" novalidate>
  <div [hidden]="osio !== 'laskutusprofiilit'">
    <div class="maksutilikortti">
      <mat-form-field>
        <mat-label>{{ 'laskuasetukset.iban' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.iban" matInput placeholder="FI00 0000 0000 0000 00" />
        <mat-error>{{ fieldErrors().iban }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'laskuasetukset.pankki' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.pankki" matInput />
        @if (!lomake.pankki().value()) {
          <mat-hint>{{ 'laskuasetukset.iban-bic-autofill' | translate | async }}</mat-hint>
        }
        <mat-error>{{ fieldErrors().pankki }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'laskuasetukset.bic' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.bic" matInput />
        @if (!lomake.bic().value()) {
          <mat-hint>{{ 'laskuasetukset.iban-bic-autofill' | translate | async }}</mat-hint>
        }
        <mat-error>{{ fieldErrors().bic }}</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div [hidden]="osio !== 'ulkoasu'">
    <h3>{{ 'laskuasetukset.laskun-ulkoasu' | translate | async }}</h3>
    <div class="asetuspino">
      <div>
        <div class="asetuskentan-otsikko">{{ 'laskuasetukset.logo.otsikko' | translate | async }}</div>
        <app-file-drop (click)="naytaTiedostonValintaDialogi()" [class.laskulogon-lataus-virhe]="kuvavirheAvain()" dropZoneClassName="laskulogon-vaihto-container" (onFileDrop)="kasitteleLogo($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
          <ng-template app-file-drop-content-tmp>
            @if (asetukset?.base64Logo) {
              <div style="position: relative">
                <img [src]="logo()" style="max-height: 125px; max-width: 125px" />
                <div lemon-loading [show]="optimoidaanKuvaa()"></div>
              </div>
              @if (!kuvavirheAvain()) {
                <p [innerHtml]="kuvanInfotekstinAvain() | translate | async"></p>
              }
            } @else {
              <div style="position: relative">
                <mat-icon class="logo-ikoni">image</mat-icon>
                <div lemon-loading [show]="optimoidaanKuvaa()"></div>
              </div>
              <span class="logo-lisaa">{{ 'laskuasetukset.logo.lisaa' | translate | async }}</span>
              <span class="logo-vihje">{{ 'laskuasetukset.logo.tiedosto-ohje' | translate | async }}</span>
              @if (!kuvavirheAvain() && kuvanInfotekstinAvain() !== 'laskuasetukset.logo.info-teksti') {
                <p [innerHtml]="kuvanInfotekstinAvain() | translate | async"></p>
              }
            }
            @if (kuvavirheAvain()) {
              <p>{{ kuvavirheAvain() | translate: kuvavirheParametrit() | async }}</p>
            }
            @if (naytaPoista()) {
              <button (click)="poistaKuva($event)" mat-button type="button" style="min-width: 0; padding: 0; text-decoration: underline">
                {{ 'laskuasetukset.logo.poista' | translate | async }}
              </button>
            }
          </ng-template>
        </app-file-drop>
        <input style="visibility: hidden" (change)="fileChanged($event)" type="file" accept="image/*" #fileInput [placeholder]="'laskuasetukset.logo.lataa' | translate | async" />
      </div>

      <mat-slide-toggle [formField]="lomake.piilotaYrityksenNimiLaskulla">{{ 'laskuasetukset.piilota-yrityksen-nimi-laskulta' | translate | async }}</mat-slide-toggle>

      <mat-form-field>
        <mat-label>{{ 'laskuasetukset.vapaamuotoinen-teksti' | translate | async }}</mat-label>
        <textarea rows="3" [formField]="lomake.ohjeet" matInput cdkTextareaAutosize [placeholder]="'laskuasetukset.vapaamuotoinen-teksti-placeholder' | translate | async"></textarea>
        <mat-error>{{ fieldErrors().ohjeet }}</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div [hidden]="osio !== 'oletukset'">
    <h3>{{ 'laskuasetukset.uuden-laskun-oletukset' | translate | async }}</h3>
    <div class="asetusruudukko">
      <mat-form-field>
        <mat-label>{{ 'laskuasetukset.oletusmaksuehto' | translate | async }}</mat-label>
        <mat-select [formField]="lomake.oletusMaksuaikaa">
          @for (paivia of maksuaikaVaihtoehdot(); track paivia) {
            <mat-option [value]="paivia">{{ paivia }} {{ 'lasku.pv-netto' | translate | async }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="leveä">
        <mat-label>{{ 'laskuasetukset.verottoman-myynnin-oletusperuste' | translate | async }}</mat-label>
        <mat-select [formField]="lomake.verottomanMyynninOletusperuste" [canSelectNullableOptions]="true">
          <mat-option [value]="null">{{ 'laskuasetukset.ei-oletusta' | translate | async }}</mat-option>
          @for (peruste of verottomanMyynninPerusteet; track peruste) {
            <mat-option [value]="peruste">{{ 'verottoman-myynnin-peruste.' + peruste | translate | async }}</mat-option>
          }
        </mat-select>
        <mat-hint>{{ 'laskuasetukset.verottoman-myynnin-oletusperuste-vihje' | translate | async }}</mat-hint>
      </mat-form-field>
    </div>
    <div class="alv-rekisteri">
      <span class="alv-rekisteri-otsikko">{{ 'laskuasetukset.kuuluu-alv-rekisteriin' | translate | async }}:</span>
      <b>{{ alvRekisterinTilaAvainObservable | async | translate | async }}</b>
      <span class="asetusvihje alv-rekisteri-selite">
        <mat-icon>lock</mat-icon>
        {{ 'laskuasetukset.alv-rekisteri-selite' | translate | async }}
      </span>
    </div>
    @if ((alvRekisterissaObservable | async) === false) {
      <div class="asetusvihje alv-rekisteri-rajoitukset">{{ 'laskuasetukset.alv-rekisteri-ei-rajoitukset' | translate | async }}</div>
    }
    @if (alvRekisterissaObservable | async) {
      <mat-slide-toggle class="hinnat-verollisina" [formField]="lomake.laskurivienHinnatVerollisina">{{ 'laskuasetukset.laskurivien-hinnat-verollisina' | translate | async }}</mat-slide-toggle>
    }
  </div>

  <div class="asetusnappulat">
    <button class="primarybutton" mat-button (click)="save()" type="button">{{ 'yleiset.tallenna' | translate | async }}</button>
  </div>
</form>
